import { domains, type environmentNames } from 'ui/config/constants';
import type { ComponentCustomProperties } from 'vue';
import { getConfigString } from 'ui/util/getConfigString';

export interface ENVValues {
  app_env: environmentNames,
  app_url: string,
  api_url: string,
}

export const getConfig = (allEnv: ComponentCustomProperties['$config']) => {
  const appEnv = getConfigString('app_env', allEnv) as environmentNames;
  const config = {
    env: appEnv,
    isLocal: appEnv === 'local',
    domains: domains[appEnv],
    appURL: domains[appEnv].partnerPortal,
    api: domains[appEnv].api,
  };
  return config;
};
